'use client';

import CWSpinner from '@/context/global/components/g00/g00-d00-g005-cw-spinner';
import CWHeroBannerCarousel from '@/context/global/components/g02/g02-d01/g02-d01-g001-cw-hero-banner-carousel';
import CWSongCategoriesSection from '@/context/global/components/g02/g02-d01/g02-d01-g003-cw-song-categories-section';
import CWSongCoversSection from '@/context/global/components/g02/g02-d01/g02-d01-g004-cw-song-covers-section';
import CWSongRankingSection from '@/context/global/components/g02/g02-d01/g02-d01-g005-cw-song-ranking-section';
import CWEventSingleCard from '@/context/global/components/g02/g02-d01/g02-d01-g009-cw-event-single-card';
import { useHomeShelves } from '@/context/domain/g02/g02-d01/g02-d01-p001-main/hooks/useHomeShelves';
import React from 'react';

export default function CWContentShelve() {
  const { shelves, loading, error } = useHomeShelves('th', true);

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <CWSpinner size={48} />
      </div>
    );
  }
  if (error) {
    // TODO: handle this
    return (
      <div className="flex w-full justify-center py-12 text-lg text-red-500">
        Error: {error}
      </div>
    );
  }

  return (
    <main
      className="mb-18 flex w-full flex-col items-center gap-5 md:gap-10"
      data-node-id="content-shelves"
    >
      {shelves.map((shelf, idx) => {
        switch (shelf.type) {
          case 'banner_1':
            return (
              <section
                key={idx}
                className="mb-0 flex w-full items-center justify-center px-0 md:px-0"
              >
                <CWHeroBannerCarousel items={shelf.items} />
              </section>
            );
          case 'categoryHorizontalScroll':
            return (
              <div key={idx} className="w-full px-4 md:px-[16px] lg:px-[50px] 2xl:px-[80px]">
                <CWSongCategoriesSection shelf={shelf} />
              </div>
            );
          case 'songHorizontalScroll':
            return (
              <div key={idx} className="w-full px-4 md:px-[16px] lg:px-[50px] 2xl:px-[80px]">
                <CWSongCoversSection shelf={shelf} />
              </div>
            );
          case 'songRanking':
            return (
                 <div key={idx} className="w-full px-4 md:px-[16px] lg:px-[50px] 2xl:px-[80px]">
                <CWSongRankingSection shelf={shelf} />
              </div>
            );
          case 'eventSingleCard':
            return (
              <div key={idx} className="w-full px-4 md:px-[16px] lg:px-[50px] 2xl:px-[80px]">
                <CWEventSingleCard shelf={shelf} />
              </div>
            );
          default:
            return null;
        }
      })}
    </main>
  );
}
